<app-layout pageTitle="Início" [fillPrimary]="true">
  <app-certificate-expiration></app-certificate-expiration>
  <section class="dashboard">
    <app-nfes-cfop-widget></app-nfes-cfop-widget>
    <app-nfes-payment-widget></app-nfes-payment-widget>
  </section>
</app-layout>
